import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Result, Button } from "antd";

import { useQuery } from "../../hooks/useQuery";
import { request } from "../../config/API";
import { useDispatch } from "react-redux";
import { LOGIN_SUCCESS } from "../../redux/actions/Auth/authTypes";
import { LoadingOutlined } from "@ant-design/icons";
import { COLORS } from "../../config/theme";
import { useHistory } from "react-router-dom";

const { primaryDark } = COLORS;

const OAuthProcess = () => {
  const searchParams = useQuery();
  const dispatch = useDispatch();
  const history = useHistory();

  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const [isLoading, setIsLoading] = useState(false);
  const [userToken, setUserToken] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const [status, setStatus] = useState();
  const [textContent, setTextContent] = useState();

  useEffect(() => {
    setIsLoading(true);
    request
      .post(
        "/authenticate/oauth2",
        {
          code,
        },
        {
          params: {
            state,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        const data = response.data;
        if (response.data.data.token) {
          setStatus("success");
          setUserToken({ user: data, token: response.data.data.token });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response?.data?.data) {
          setStatus("error");
          setErrorMessage(error.response?.data?.data);
        } else if ("string" === typeof error) {
          setStatus("error");
          setErrorMessage(error);
        } else {
          setStatus("error");
          setErrorMessage("Failed to login!");
        }

        setTimeout(() => {
          history.push("/login");
        }, 3000);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status === "success") {
      setTextContent({
        status: "success",
        title: "",
        subTitle: "You will redirect to dashboard automatically",
        extra: [
          <Button
            shape="round"
            type="primary"
            style={{ background: primaryDark, borderColor: primaryDark }}
            key="dashboard"
            onClick={() => history.push("/")}
          >
            Go Dashboard
          </Button>,
        ],
      });
    }

    if (status === "error") {
      setTextContent({
        status: "error",
        title: "",
        subTitle: errorMessage,
        extra: [],
      });
    }
  }, [errorMessage, status, history]);

  useEffect(() => {
    if (userToken) {
      localStorage.setItem("user", JSON.stringify(userToken.token));

      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: userToken.user },
      });
    }

    return () => {
      setUserToken(null);
    };
  }, [dispatch, userToken]);

  return (
    <div className={styles.main}>
      {isLoading && (
        <>
          <Result
            icon={<LoadingOutlined></LoadingOutlined>}
            subTitle={"Validating ..."}
          />
        </>
      )}
      {textContent && !isLoading && (
        <Result
          status={textContent.status}
          title={textContent.title}
          subTitle={textContent.subTitle}
          extra={textContent.extra}
        />
      )}
    </div>
  );
};

export default OAuthProcess;
